import { Button, ButtonToolbar } from 'reactstrap';
import InfoIcon from '../icons/InfoIcon';

const CluLayerToolbar = () => (
  <ButtonToolbar className="align-items-center mr-2">
    <Button className="d-flex ml-2 font-small align-items-center" disabled>
      <InfoIcon className="mr-1" />
      <span>This layer is deprecated and cannot be reloaded</span>
    </Button>
  </ButtonToolbar>
);

export default CluLayerToolbar;
